
/* ========================================
   ROSE & LOUIS — TEMPORIZADOR 10 MINUTOS
   Broadcast 6.2.0
======================================== */

(() => {
  const DURATION = 10 * 60 * 1000;
  const STORAGE_KEY = 'rl_cart_timer_start_v1';

  let startedAt = null;
  let interval = null;

  function readStart() {
    try {
      const saved = sessionStorage.getItem(STORAGE_KEY);
      return saved === null ? null : Number(saved);
    } catch (error) {
      return startedAt;
    }
  }

  function saveStart(value) {
    startedAt = value;

    try {
      sessionStorage.setItem(STORAGE_KEY, String(value));
    } catch (error) {}
  }

  function render() {
    if (startedAt === null) return;

    const elapsed = Date.now() - startedAt;
    const remaining = Math.max(0, DURATION - elapsed);

    const seconds = Math.ceil(remaining / 1000);
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;

    const formatted =
      String(minutes).padStart(2, '0') + ':' +
      String(secs).padStart(2, '0');

    document.querySelectorAll(
      '[data-rl-cart-timer]'
    ).forEach(element => {
      element.textContent = formatted;
    });

    if (remaining <= 0 && interval !== null) {
      clearInterval(interval);
      interval = null;
    }
  }

  function start() {
    if (startedAt !== null) return;

    const saved = readStart();

    if (saved !== null && Number.isFinite(saved)) {
      saveStart(saved);
    } else {
      saveStart(Date.now());
    }

    render();

    if (interval === null) {
      interval = setInterval(render, 1000);
    }
  }

  function observeDrawer() {
    const timer = document.querySelector(
      '[data-rl-cart-timer]'
    );

    if (!timer) return;

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          start();
          observer.disconnect();
        }
      }, { threshold: 0.1 });

      observer.observe(timer);
    } else {
      start();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      observeDrawer
    );
  } else {
    observeDrawer();
  }
})();
